/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
import MuiDialog, { ButtonPosition } from '@components/Alert/Dialog';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  List,
  ListItemText,
  MenuItem,
  MenuList,
  ListItem as MuiLisItem,
  Popover,
  Tooltip,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import {
  CachedRounded,
  ChevronRightRounded,
  CloseRounded,
  DeleteOutlineRounded,
  DoneRounded,
  EditRounded,
  MicNoneRounded,
  MicRounded,
  RefreshRounded,
  ReportProblemOutlined,
  SendRounded,
  ShortTextRounded,
  StopRounded,
  SubjectRounded,
  TranslateRounded,
} from '@material-ui/icons';
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@material-ui/icons/KeyboardArrowUpOutlined';
import { MediaType, MessagingProvider } from '@model/frontendmodel';
import psychology from '@src/images/psychology.svg';
import { parseMessage } from '@src/locales/intl';
import { ChatMessage, queueChatMessage } from '@src/reducers/chatMessageQueue';
import {
  changeTransformTextAI,
  fetchCloseErrorMsg,
  fetchTextActionAI,
  fetchTransformTextAI,
} from '@src/reducers/chats';
import {
  activeChatSelector,
  transformTextAISelector,
} from '@src/selectors/chats';
import { CommandAIEnum, LanguageEnum, TextActionEnum } from '@src/types';
import mediaUtils from '@utils/mediaUtils';

import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import CustomEmojiPicker from '../CustomEmojiPicker';
import {
  AttachFileIcon,
  AttachImageIcon,
  EmojiIcon,
  QuickMessagesIcon,
  StickerIcon,
} from './SvgIcons';

const boxCss = {
  display: 'flex',
  gridGap: '5px',
  alignItems: 'center',
  padding: '2px 0',
};
const BG_GRAY = '#F4F4F5';
const lblBtnAI = parseMessage('Chat.AI.Button');
const lblAISelection = parseMessage('Chat.AI.EditReviewSelecion');
const lblAIimprove = parseMessage('Chat.AI.ImproveWriting');
const lblAIExpand = parseMessage('Chat.AI.ExpandText');
const lblAIReduce = parseMessage('Chat.AI.ReduceText');
const lblAICasual = parseMessage('Chat.AI.Casual');
const lblAIFormal = parseMessage('Chat.AI.Formal');
const lblAITranslate = parseMessage('Chat.AI.Translate');
const lblEnglish = parseMessage('Chat.AI.Translate.English');
const lblSpanish = parseMessage('Chat.AI.Translate.Spanish');
const lblFrench = parseMessage('Chat.AI.Translate.French');
const lblPortuguese = parseMessage('Chat.AI.Translate.Portuguese');
const lblGerman = parseMessage('Chat.AI.Translate.German');
const lblItalian = parseMessage('Chat.AI.Translate.Italian');
const lblJapanese = parseMessage('Chat.AI.Translate.Japanese');
const lblKorean = parseMessage('Chat.AI.Translate.Korean');
const lblChinese = parseMessage('Chat.AI.Translate.Chinese');
const lblNoAvailable = parseMessage('Chat.AI.NoAvailable');
const lblClose = parseMessage('Chat.AI.NoAvailable.BtnClose');
const lblRetry = parseMessage('Chat.AI.NoAvailable.BtnRetry');
const lblAIReplaceText = parseMessage('Chat.Action.ReplaceText');
const lblAIReplaceSend = parseMessage('Chat.Action.ReplaceSend');
const lblAITryAgain = parseMessage('Chat.Action.TryAgain');
const lblAIDiscard = parseMessage('Chat.Action.Discard');
const lblAIQuestion = parseMessage('Chat.AI.Dialog.Question');
const lblAICancel = parseMessage('Chat.AI.Dialog.Cancel');
const lblStopAI = parseMessage('Chat.AI.Help.Stop');

const useStyles = makeStyles(theme => ({
  paper: {
    margin: '-7px 0',
    boxShadow: '0px 0px 10px 2px rgba(0, 0, 0, 0.4)',
  },
  language: {
    boxShadow: '0px 0px 10px 2px rgba(0, 0, 0, 0.4)',
    margin: '5px',
  },
  listRoot: {
    boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.08)',
    borderRadius: '14px',
    background: theme.palette.type === 'dark' ? '#1E2128' : BG_GRAY,
    color: theme.palette.text.primary,
    fontSize: '12px',
  },
  lisItem: {
    padding: '3px 0px',
  },
  stickersIconButton: {
    color: theme.palette.primary.main,
  },
  resumeAi: {
    boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.08)',
    borderRadius: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '8px 8px 2px',
    maxHeight: '150px',
    border: `1px solid ${theme.palette.primary.main}`,
  },
  resumeAiTitle: {
    color: theme.palette.primary.main,
  },
}));

const languages = [
  {
    name: lblEnglish,
    code: LanguageEnum.ENGLISH,
  },
  {
    name: lblSpanish,
    code: LanguageEnum.SPANISH,
  },
  {
    name: lblItalian,
    code: LanguageEnum.ITALIAN,
  },
  {
    name: lblFrench,
    code: LanguageEnum.FRENCH,
  },
  {
    name: lblPortuguese,
    code: LanguageEnum.PORTUGUESE,
  },
  {
    name: lblGerman,
    code: LanguageEnum.GERMAN,
  },
  {
    name: lblJapanese,
    code: LanguageEnum.JAPANESE,
  },
  {
    name: lblKorean,
    code: LanguageEnum.KOREAN,
  },
  {
    name: lblChinese,
    code: LanguageEnum.CHINESE,
  },
];

interface IResizeButtonsWrapper {
  handleShrinkComposeTextBox: () => void;
  handleStretchComposeTextBox: () => void;
}

export const ResizeButtonsWrapper: React.FC<IResizeButtonsWrapper> = ({
  handleShrinkComposeTextBox,
  handleStretchComposeTextBox,
}) => {
  const resizeBtnStyles = {
    color: '#757575',
    fontSize: '0.75em',
    cursor: 'pointer',
  };
  return (
    <div className="ResizeButtonsWrapper">
      <KeyboardArrowDownOutlinedIcon
        className="material-icons"
        style={{ marginRight: '0.75em', ...resizeBtnStyles }}
        onClick={handleShrinkComposeTextBox}
      />
      <KeyboardArrowUpOutlinedIcon
        className="material-icons"
        style={resizeBtnStyles}
        onClick={handleStretchComposeTextBox}
      />
    </div>
  );
};

const MuiTooltip = withStyles({
  tooltip: {
    backgroundColor: 'rgba(0,0,0,.8)',
    color: '#fff',
    overflowY: 'hidden',
  },
})(Tooltip);

interface IToolbarWrapper {
  searchQuickMessages: () => void;
  handleOpenEmoticonSelector: () => void;
  emoticonBtn: any;
  isFileSubmissionEnabled: boolean;
  msgProvider: any;
  handleOpenDocumentToSend: () => void;
  handleOpenImageToSend: () => void;
  handleOpenStickerToSend: () => void;
}

/* READY */
export const ToolbarWrapper: React.FC<IToolbarWrapper> = ({
  searchQuickMessages,
  handleOpenEmoticonSelector,
  emoticonBtn,
  isFileSubmissionEnabled,
  msgProvider,
  handleOpenDocumentToSend,
  handleOpenImageToSend,
  handleOpenStickerToSend,
}) => {
  const { stickersIconButton } = useStyles();

  return (
    <Box display="flex" flexWrap="nowrap">
      {isFileSubmissionEnabled &&
        msgProvider &&
        mediaUtils.isMediaTypeSupported(MediaType.STICKER, msgProvider) && (
          <IconButton
            className={stickersIconButton}
            style={{ padding: '0 12px 0 12px' }}
            onClick={handleOpenStickerToSend}
          >
            {StickerIcon}
          </IconButton>
        )}
      <MuiTooltip
        placement="top"
        title={<FormattedMessage id="ChatMessageComposer.quickMessagesTitle" />}
      >
        <IconButton
          style={{ padding: '0 12px 0 12px' }}
          onClick={searchQuickMessages}
        >
          {QuickMessagesIcon}
        </IconButton>
      </MuiTooltip>

      <IconButton
        style={{ padding: '0 12px 0 12px' }}
        onClick={handleOpenEmoticonSelector}
        ref={emoticonBtn}
      >
        {EmojiIcon}
      </IconButton>
      {
        // Show the send-file button only if the current user has it enabled (see UtilityController, getGeneralProperties)
        isFileSubmissionEnabled &&
          msgProvider &&
          mediaUtils.isMediaTypeSupported(MediaType.FILE, msgProvider) && (
            <IconButton
              style={{ padding: '0 12px 0 12px' }}
              onClick={handleOpenDocumentToSend}
            >
              {AttachFileIcon}
            </IconButton>
          )
      }
      {isFileSubmissionEnabled &&
        msgProvider &&
        mediaUtils.isMediaTypeSupported(MediaType.IMAGE, msgProvider) && (
          <IconButton onClick={handleOpenImageToSend}>
            {AttachImageIcon}
          </IconButton>
        )}
    </Box>
  );
};
interface IEmojisAndDialogs {
  emoticonSelector: {
    open: boolean;
    anchorEl?: HTMLAnchorElement;
  };
  handleCloseEmoticonSelector: () => void;
  handleAppendEmoticon: (emoji: string) => void;
  openImagePreview: boolean;
  createImagePreviewURL: () => string;
  handleImagePreviewClose: () => void;
  handleImagePreviewSend: () => void;
  handleSendSticker: (file: File) => void;
  cancelLabel: string;
  sendLabel: string;
  msgProvider: unknown;
}
/* READY */
export const EmojisAndDialogs: React.FC<IEmojisAndDialogs> = ({
  emoticonSelector,
  handleCloseEmoticonSelector,
  handleAppendEmoticon,
  openImagePreview,
  createImagePreviewURL,
  handleImagePreviewClose,
  handleImagePreviewSend,
  handleSendSticker,
  cancelLabel,
  sendLabel,
  msgProvider,
}) => (
  <>
    <Popover
      open={emoticonSelector.open}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      marginThreshold={55}
      anchorEl={emoticonSelector.anchorEl}
      onClose={handleCloseEmoticonSelector}
    >
      <CustomEmojiPicker
        handleSendSticker={handleSendSticker}
        handleAppendEmoticon={handleAppendEmoticon}
        withUploadOption
        withStickersOption={mediaUtils.isMediaTypeSupported(
          MediaType.STICKER,
          msgProvider as MessagingProvider
        )}
      />
    </Popover>

    <Dialog open={openImagePreview}>
      <DialogContent>
        <img
          src={createImagePreviewURL()}
          style={{ width: '100%', height: '100%', maxHeight: '450px' }}
          alt="Preview"
        />
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleImagePreviewClose}
        >
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleImagePreviewSend}
        >
          {sendLabel}
        </Button>
      </DialogActions>
    </Dialog>
  </>
);

export const ImproveTextAI: React.FC<{ disabled: boolean }> = ({
  disabled,
}) => {
  const [anchorAI, setAnchorAI] = useState<HTMLElement | null>(null);
  const [anchorLanguage, setAnchorLanguage] = useState<HTMLElement | null>(
    null
  );
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    const { currentTarget } = event;
    if (currentTarget.localName === 'button') {
      setAnchorAI(currentTarget);
    } else {
      setIsOpen(true);
      setAnchorLanguage(currentTarget);
    }
  };

  const handlePopoverClose = (
    _event: React.MouseEvent<HTMLElement, MouseEvent>,
    reason: string
  ) => {
    if (reason === 'backdropClick') {
      if (isOpen) {
        setAnchorLanguage(null);
        setIsOpen(false);
      } else {
        setAnchorLanguage(null);
        setAnchorAI(null);
      }
    }
  };

  const onTranslate = (language: string) => {
    setAnchorLanguage(null);
    setAnchorAI(null);
    setIsOpen(false);
    dispatch(
      fetchTransformTextAI({
        command: CommandAIEnum.TRANSLATE,
        language,
      })
    );
  };

  const onCommand = (command: CommandAIEnum) => {
    setAnchorAI(null);
    dispatch(fetchTransformTextAI({ command: command.toString() }));
  };

  const open = Boolean(anchorAI);
  const openLanguages = Boolean(anchorLanguage);

  return (
    <>
      <Popover
        id="popover-languages"
        open={openLanguages}
        anchorEl={anchorLanguage}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          classes: { root: useStyles().language },
        }}
        onClose={handlePopoverClose}
      >
        <MenuList className={useStyles().listRoot}>
          {languages.map(item => (
            <MenuItem key={item.code} onClick={() => onTranslate(item.code)}>
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
      <Popover
        id="popover-ai"
        open={open}
        anchorEl={anchorAI}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          classes: { root: useStyles().paper },
        }}
        onClose={handlePopoverClose}
      >
        <MenuList className={useStyles().listRoot}>
          <Box sx={{ padding: '10px' }}>{lblAISelection}</Box>
          <MenuItem onClick={() => onCommand(CommandAIEnum.IMPROVE)}>
            <Box sx={boxCss}>
              <EditRounded fontSize="small" />
              {lblAIimprove}
            </Box>
          </MenuItem>
          <MenuItem onClick={handlePopoverOpen}>
            <Box
              display="flex"
              width="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box sx={boxCss}>
                <TranslateRounded fontSize="small" />
                {lblAITranslate}
              </Box>
              <ChevronRightRounded fontSize="small" />
            </Box>
          </MenuItem>
          <MenuItem onClick={() => onCommand(CommandAIEnum.LONGER)}>
            <Box sx={boxCss}>
              <SubjectRounded fontSize="small" />
              {lblAIExpand}
            </Box>
          </MenuItem>
          <MenuItem onClick={() => onCommand(CommandAIEnum.SHORTER)}>
            <Box sx={boxCss}>
              <ShortTextRounded fontSize="small" />
              {lblAIReduce}
            </Box>
          </MenuItem>
          <MenuItem onClick={() => onCommand(CommandAIEnum.CASUAL)}>
            <Box sx={boxCss}>
              <MicRounded fontSize="small" />
              {lblAICasual}
            </Box>
          </MenuItem>
          <MenuItem onClick={() => onCommand(CommandAIEnum.FORMAL)}>
            <Box sx={boxCss}>
              <MicNoneRounded fontSize="small" />
              {lblAIFormal}
            </Box>
          </MenuItem>
        </MenuList>
      </Popover>
      <Button
        size="small"
        variant="contained"
        color="primary"
        startIcon={<img src={psychology} alt="psychology" />}
        style={{
          fontSize: '0.9rem',
          padding: '1px 8px',
          whiteSpace: 'nowrap',
          minWidth: 'min-content',
          borderRadius: '14px',
        }}
        onClick={handlePopoverOpen}
        disabled={disabled}
      >
        {lblBtnAI}
      </Button>
    </>
  );
};

export const ActionsAI = (): React.ReactElement => {
  const {
    outputText,
    error,
    closeErrorMsg,
    requestParams,
    disabledStop,
    loading,
  } = useSelector(transformTextAISelector);
  const activeChat = useSelector(activeChatSelector);
  const initialState = {
    newText: '',
    longitude: 1,
  };
  const [write, setWrite] = useState<{
    newText: string;
    longitude: number;
  }>(initialState);
  const [show, setShow] = useState(false);
  const customStyle = useStyles();
  const dispatch = useDispatch();
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (outputText && !disabledStop) {
      intervalRef.current = window.setInterval(() => {
        setWrite(prevState => ({
          ...prevState,
          newText: outputText.substring(0, prevState.longitude),
          longitude: prevState.longitude + 1,
        }));
      }, 20);
    }

    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
        setWrite(initialState);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outputText]);

  const onClick = (actionClick: ButtonPosition) => {
    if (actionClick === ButtonPosition.right) {
      dispatch(fetchTextActionAI(TextActionEnum.DISCARD));
    }
    setShow(!show);
  };

  const onAction = (action: string) => {
    if ([lblRetry, lblAITryAgain].includes(action)) {
      if (requestParams) dispatch(fetchTransformTextAI(requestParams));
    }
    if (action === lblAIReplaceText) {
      dispatch(fetchTextActionAI(TextActionEnum.REPLACE));
    }
    if (action === lblAIReplaceSend) {
      if (activeChat) {
        dispatch(
          queueChatMessage(
            {
              type: MediaType.TEXT,
              text: outputText,
            } as ChatMessage,
            activeChat.id,
            activeChat.provider
          )
        );
        dispatch(fetchTextActionAI(TextActionEnum.REPLACE_SEND));
      }
    }
  };

  return (
    <>
      <MuiDialog
        rightButton={lblAIDiscard}
        leftButton={lblAICancel}
        title={lblBtnAI}
        show={show}
        handleClick={onClick}
        showIcon={false}
        disableRightBtn={false}
      >
        <Typography>{lblAIQuestion}</Typography>
      </MuiDialog>

      {outputText && (
        <Box id="help-ai">
          <Box id="resume-ai" className={customStyle.resumeAi}>
            <Typography
              id="resume-ai-title"
              className={customStyle.resumeAiTitle}
            >
              {parseMessage(`Chat.AI.Help.${requestParams?.command}`)}
            </Typography>
            <Box id="resume-ai-content">
              <Typography component="span" id="resume-ai-body">
                {write.newText}
              </Typography>
            </Box>

            <Box id="resume-ai-stop">
              <Button
                disabled={disabledStop}
                startIcon={<StopRounded fontSize="small" />}
                onClick={event => {
                  event.preventDefault();
                  if (intervalRef.current) {
                    window.clearInterval(intervalRef.current);
                    intervalRef.current = null;
                    dispatch(changeTransformTextAI(write.newText));
                    setWrite(prevState => ({
                      ...prevState,
                      longitude: 1,
                    }));
                  }
                }}
                size="small"
              >
                <u>{lblStopAI}</u>
              </Button>
            </Box>
          </Box>
          <List component="nav" classes={{ root: customStyle.listRoot }}>
            <MuiLisItem
              classes={{ root: customStyle.lisItem }}
              button
              onClick={() => onAction(lblAIReplaceText)}
            >
              <Box sx={boxCss}>
                <DoneRounded fontSize="small" />
                {lblAIReplaceText}
              </Box>
            </MuiLisItem>
            <MuiLisItem
              classes={{ root: customStyle.lisItem }}
              button
              onClick={() => onAction(lblAIReplaceSend)}
            >
              <Box sx={boxCss}>
                <SendRounded fontSize="small" />
                {lblAIReplaceSend}
              </Box>
            </MuiLisItem>
            <MuiLisItem
              classes={{ root: customStyle.lisItem }}
              button
              onClick={() => onAction(lblAITryAgain)}
            >
              <Box sx={boxCss}>
                <CachedRounded fontSize="small" />
                {lblAITryAgain}
              </Box>
            </MuiLisItem>
            <MuiLisItem
              classes={{ root: customStyle.lisItem }}
              button
              onClick={() => {
                setShow(!show);
              }}
            >
              <Box sx={boxCss}>
                <DeleteOutlineRounded fontSize="small" />
                {lblAIDiscard}
              </Box>
            </MuiLisItem>
          </List>
        </Box>
      )}
      {loading === 'pending' && (
        <Box id="error-ai">
          <Typography id="resume-ai-title">
            {parseMessage(`Chat.AI.Help.${requestParams?.command}`)}
          </Typography>
          <Box id="resume-ai-content">
            <Typography component="span" id="resume-ai-body" />
          </Box>
        </Box>
      )}
      {error && !closeErrorMsg && (
        <Box id="error-ai">
          <Box id="error-ai_message">
            <ReportProblemOutlined fontSize="small" />
            {lblNoAvailable}
          </Box>
          <Box id="error-ai_actions">
            <Button
              size="small"
              startIcon={<RefreshRounded fontSize="small" />}
              onClick={() => onAction(lblRetry)}
            >
              <u>{lblRetry}</u>
            </Button>
            <Button
              size="small"
              onClick={() => dispatch(fetchCloseErrorMsg())}
              startIcon={<CloseRounded fontSize="small" />}
            >
              <u>{lblClose}</u>
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ResizeButtonsWrapper;
